/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* MRD_GLOBAL_STICKY_HEADER_2026_10_22
 * Site-wide sticky header with measured width and no layout jump.
 * Replaces the old header-only scrollToFixed behavior; does not
 * affect sticky product boxes, FAQ categories, or navigation drawers.
 */
(function () {
  'use strict';

  var header;
  var spacer;
  var container;
  var headerStart = 0;
  var isFixed = false;
  var scheduled = false;

  function scrollY() {
    return Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
  }

  function setFixed(shouldFix) {
    if (isFixed === shouldFix) return;
    isFixed = shouldFix;

    if (shouldFix) {
      spacer.style.height = header.offsetHeight + 'px';
      header.classList.add('mrd-global-sticky-active');
    } else {
      header.classList.remove('mrd-global-sticky-active');
      header.style.removeProperty('left');
      header.style.removeProperty('width');
      spacer.style.height = '0px';
    }
  }

  function refresh() {
    scheduled = false;
    if (!header || !document.documentElement.contains(header)) return;

    setFixed(scrollY() > headerStart);

    if (isFixed) {
      var rect = (container || document.documentElement).getBoundingClientRect();
      header.style.left = rect.left + 'px';
      header.style.width = rect.width + 'px';
      spacer.style.height = header.offsetHeight + 'px';
    }
  }

  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(refresh);
  }

  function remeasure() {
    if (!header) return;
    setFixed(false);
    headerStart = scrollY() + header.getBoundingClientRect().top;
    scheduleRefresh();
  }

  function init() {
    var el = document.querySelector('header.js-header');
    if (!el || el.hasAttribute('data-mrd-global-sticky')) return;
    header = el;
    // Venue's optional scroll-hide class can translate the header off-screen.
    // The global sticky implementation replaces that behavior site-wide.
    header.classList.remove('js-header-scroll');
    header.style.removeProperty('transform');
    header.style.removeProperty('-webkit-transform');
    header.style.removeProperty('-moz-transform');
    document.body.classList.remove('header-up');
    container = document.querySelector('.page-container');
    header.setAttribute('data-mrd-global-sticky', '1');

    // The legacy Venue script initializes earlier. Detach only the
    // header's scrollToFixed handler so two systems cannot compete.
    if (window.jQuery) {
      window.jQuery(header).trigger('detach.ScrollToFixed');
    }

    spacer = document.createElement('div');
    spacer.id = 'mrd-global-sticky-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    header.parentNode.insertBefore(spacer, header);

    headerStart = scrollY() + header.getBoundingClientRect().top;
    window.addEventListener('scroll', scheduleRefresh, { passive: true });
    window.addEventListener('resize', remeasure, { passive: true });
    window.addEventListener('orientationchange', remeasure, { passive: true });
    window.addEventListener('load', remeasure);
    // Safari back/forward cache restores scroll position without re-running DOM ready.
    window.addEventListener('pageshow', remeasure);
    scheduleRefresh();
  }

  // Venue registers its DOM-ready handlers before custom.js, allowing
  // the native sticky replacement to run after the legacy initializer.
  if (window.jQuery) {
    window.jQuery(function () { window.setTimeout(init, 0); });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
 

/* MRD_MOBILE_SUBMENU_TOGGLE_2026_10_22
 * Capture clicks on links that expand a mobile-drawer submenu.
 * Venue also registers an ordinary jQuery click handler; intercept here
 * so the submenu isn't toggled twice and the anchor cannot jump pages.
 * Delegation survives the drawer being moved into the popup container.
 */
(function () {
  'use strict';

  function toggleSubmenu(event) {
    var clicked = event.target;
    if (!clicked || !clicked.closest) return;

    var trigger = clicked.closest('.js-menu-draw .js-toggle-trigger');
    if (!trigger) return;

    var href = trigger.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;

    var menu = trigger.closest('.js-menu-draw');
    var target = document.getElementById(href.slice(1));
    if (!menu || !target || !menu.contains(target) || !target.classList.contains('js-toggle-target')) return;

    event.preventDefault();
    // Block Venue's bubble-phase toggle to prevent duplicate expand/collapse.
    event.stopPropagation();

    var isOpen = trigger.classList.toggle('js-active');
    target.classList.toggle('js-active', isOpen);
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    var item = trigger.parentElement;
    if (item) item.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  document.addEventListener('click', toggleSubmenu, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== ' ' && event.key !== 'Spacebar') return;
    var trigger = event.target;
    if (!trigger || !trigger.matches || !trigger.matches('.js-menu-draw .js-toggle-trigger')) return;
    event.preventDefault();
    trigger.click();
  }, true);
})();
